import { useNavigate } from "react-router";

const useCustomNavigate = () => {
  const navigate = useNavigate();

  const goTo = (path: string) => {
    navigate(path);
  };

  const goBack = () => {
    navigate(-1);
  };

  const goHome = () => {
    navigate("/");
  };

  return { goTo, goBack, goHome };
};

export default useCustomNavigate;
